import React from 'react';

// BugHerd #240: 옵션 설명(extra_label) 등 자유 입력 텍스트 안의 URL 을 새 창 링크로 렌더.
//   어드민이 설명에 URL 만 붙이면 클릭 가능한 외부 링크가 됨(백엔드/스키마 변경 불필요).
//   - split 캡처 그룹으로 URL/일반 텍스트를 번갈아 분리, 판별은 비-global 정규식으로(stateful lastIndex 회피).
//   #242: <a> 가 CheckBox 의 <label> 내부에 있으면 모바일에서 라벨이 탭을 가로채 링크가 안 열리고
//     체크만 토글됨(stopPropagation 은 라벨 기본동작을 못 막음). → 클릭 시 preventDefault 로 라벨
//     활성화를 취소하고 window.open 으로 새 창을 직접 띄워 어떤 브라우저에서도 확실히 열리게 한다.
//   #239 추가: 긴 URL 이 앞 텍스트("실시간 티켓 확인: ") 뒤에 붙어 URL 중간에서 잘려 내려오던 문제 →
//     앵커를 block 으로 만들어 URL 전체가 자기 줄로 내려가게(데스크탑/모바일 공통). break-all 유지.
const URL_SPLIT = /(https?:\/\/[^\s]+)/g;
const isUrl = (s) => /^https?:\/\//.test(s);

export function renderTextWithLinks(text) {
  if (typeof text !== 'string' || !text) return text;
  return text.split(URL_SPLIT).map((part, i) =>
    isUrl(part) ? (
      <a
        key={i}
        href={part}
        target="_blank"
        rel="noopener noreferrer"
        className="text-orange-500 underline break-all block"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(part, '_blank', 'noopener,noreferrer');
        }}
      >
        {part}
      </a>
    ) : (
      part
    )
  );
}
